export default __webpack_public_path__ + "static/media/eye_-anim-800.fb7dcbda.gif";